import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminInternationalTranslations from "@/pages/admin/AdminInternationalTranslations";

export const Route = createFileRoute("/admin/internacional/traducoes")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminInternationalTranslations />
    </AdminRoute>
  ),
});
